export const playIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 5.13965V19.1396L19 12.1396L8 5.13965Z" fill="white"/>
</svg>

`;
